import { Injectable, Injector } from "@angular/core";
import { HttpWrapperService } from "./http.wrapper.service";
import { SessionManagerService } from "./SessionManager/session-manager.service";
import { observableToPromise } from "../admin/events-screen/utils/observableToPromise";
import { FilesService } from "./files.service";
import { LoggerService } from "../modules/logger/logger.service";
import { AlertService } from "./alert.service";
import { TranslationService } from "./translation.service";
import { sleep } from "../_helpers/sleep";
import { BehaviorSubject } from "rxjs/BehaviorSubject";

@Injectable()
export class DownloadReceiptService {
  private activeDownloads = new BehaviorSubject<Set<number>>(new Set());
  constructor(
    private http: HttpWrapperService,
    private filesService: FilesService,
    private sessionManager: SessionManagerService,
    private translationService: TranslationService,
    private logger: LoggerService,
    private injector: Injector,
    private alertService: AlertService
  ) {}

  public async downloadReceiptByNumber(receiptNumber: number): Promise<any> {
    try {
      if (this.activeDownloads.value.has(receiptNumber)) {
        return;
      }
      this.activeDownloads.next(
        new Set([...Array.from(this.activeDownloads.value), receiptNumber])
      );
      await this.receiptDownloadStage("preparing");

      const body = { receipt_number: receiptNumber };

      const urlResponse = await observableToPromise(
        this.http.post(`django-api/payments/get-receipt-url/`, { ...body })
      );
      const responseBody = (await urlResponse.json()) as {
        receipt_url: string;
      };
      const fileName = `receipt-${receiptNumber}.pdf`;

      const downloadResult =
        await this.filesService.downloadFileFromExternalUrl({
          url: responseBody.receipt_url,
          fileName,
        });
      if (!downloadResult.success) {
        await this.receiptDownloadStage(
          "failure",
          (downloadResult as any).error as any
        );
        this.activeDownloads.next(new Set());
        return;
      }
      await this.receiptDownloadStage("success");
      this.activeDownloads.next(new Set());
    } catch (e) {
      await this.receiptDownloadStage("failure", e);
      this.activeDownloads.next(new Set());
    }
  }
  private async receiptDownloadStage(
    type: "preparing" | "failure" | "success",
    data?: any
  ) {
    switch (type) {
      case "preparing":
        this.alertService.info("מכין את הקבלה להורדה...", true);
        break;
      case "failure":
        this.alertService.clearAllToasts();
        await sleep(1000);
        this.alertService.error("חלה תקלה בהורדת הקבלה, אנא פנו לתמיכה", true);
        this.logger.error(data);

        break;
      case "success":
        await sleep(500);
        this.alertService.clearAllToasts();
        await sleep(400);
        this.alertService.success("הקבלה ירדה בהצלחה", true);
        break;
      default: {
        throw new Error(`Unknown notification type: ${type}`);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/download-receipt.service.ts